// src/experiences/experiencesApi.ts
import { apiClient } from "@maat/api-base";
var experiencesApi = {
  /** `experiences.create`. Always creates a `draft`; `status` is not accepted. */
  createExperience: async (data) => {
    return apiClient.post("/main/api/experiences", data);
  },
  /** `experiences.list`. Filtered, searched and paged in SQL — `{ items, hasMore }`. */
  listExperiences: async (params) => {
    return apiClient.get("/main/api/experiences", { params });
  },
  /**
   * `experiences.view`. The experience AND the listings published on it —
   * composed in the controller, because neither model may call the other's.
   */
  getExperience: async (experienceId) => {
    return apiClient.get(`/main/api/experiences/${experienceId}`);
  },
  /**
   * `experiences.update`. REPLACE semantics: every optional field absent from
   * the body is written NULL, so send the whole experience, not a patch.
   */
  updateExperience: async (experienceId, data) => {
    return apiClient.put(`/main/api/experiences/${experienceId}`, data);
  },
  /**
   * `experiences.delete` — the SOFT delete (`status: 'archived'`). Refuses with
   * `409 INVENTORY_HAS_ACTIVE_LISTINGS` (and the count) while a listing on it is
   * still sellable, rather than cascading: the listings CASCADE on a real DELETE
   * and would take booked history with them.
   */
  archiveExperience: async (experienceId) => {
    return apiClient.delete(`/main/api/experiences/${experienceId}`);
  },
  /**
   * `experiences.publish`. No `duration_minutes` — an experience listing
   * inherits the experience's own length and the schema is `.strict()`.
   */
  createExperienceListing: async (experienceId, data) => {
    return apiClient.post(`/main/api/experiences/${experienceId}/listings`, data);
  },
  // Photos — the property image pipeline, second owner kind.
  /** `experiences.update`. Reserves rows and returns one presigned POST per file. */
  presignExperienceMedia: async (experienceId, body) => {
    return apiClient.post(`/main/api/experiences/${experienceId}/media/presign`, body);
  },
  /**
   * `experiences.update`. Applies the deletes and reorder, THEN hands back
   * presigned POSTs for the additions. `media` is optional, so a pure
   * delete/reorder is this same call with an empty `uploads` array back.
   */
  presignExperienceImageEdits: async (experienceId, body) => {
    return apiClient.post(`/main/api/experiences/${experienceId}/images/presign`, body);
  },
  /** `experiences.view`. Returns UNPUBLISHED rows and AI verdicts too. */
  getExperienceImages: async (experienceId) => {
    return apiClient.get(`/main/api/experiences/${experienceId}/images`);
  },
  /** `experiences.update`. Flags an AI-declined photo; an admin decides. */
  flagExperienceImage: async (experienceId, imageId, body) => {
    return apiClient.post(`/main/api/experiences/${experienceId}/images/${imageId}/flag`, body);
  }
};

export {
  experiencesApi
};
